<template>
    <div>
        <BadgeTotal
            :value="statsGroup.typeAbsent"
            color="gray"
            title="Fresh"
        />
        <BadgeTotal
            :value="statsGroup.typeActual"
            color="green"
            title="Actual"
        />
        <BadgeTotal
            :value="statsGroup.typeUsed"
            color="red"
            title="Used"
        />
    </div>
</template>

<script>
import BadgeTotal from "../../../subcomponents/BadgeTotal";

export default {
    props: {
        ips: Array,
        groupId: Number
    },
    data() {
        return {
            ipTypes: {
                absent: 0,
                actual: 1,
                used: 2,
            }
        }
    },
    computed: {
        statsGroup: function () {
            let stats ={
                total: 0,
                typeActual: 0,
                typeUsed: 0,
                typeAbsent: 0,
            };

            this.ips && this.ips.forEach((item) => {
                if (item.group_id !== this.groupId) {
                    return;
                }
                stats.total++;
                if (item.type === this.ipTypes.actual) {
                    stats.typeActual++;
                } else if (item.type === this.ipTypes.used) {
                    stats.typeUsed++;
                } else if (item.type === this.ipTypes.absent) {
                    stats.typeAbsent++;
                }
            });

            return stats;
        }
    },
    components: {
        BadgeTotal
    }
}
</script>
